import apiBase from "./api-base";
export default class PublicClient extends apiBase {
    constructor (store) {
        const path = 'PublicClient'
        super(store, path)
    }
    GetRestaurantInfo(filter) {
        return this._request({
          action: "GetRestaurantInfo",
          method: "GET",
          params: filter,
        });
      }
}
